/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementInstructionsViewModel } from "../types/CourseRegistrationManagementInstructionsViewModel.ts";

export const courseRegistrationManagementInstructionsViewModelSchema = z.object(
  {
    instruction: z
      .string()
      .describe("Texto com as instruções da aba de gestão da matrícula.")
      .nullish(),
  },
) as unknown as ToZod<CourseRegistrationManagementInstructionsViewModel>;
